import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { useTranslation } from "react-i18next"

export type AddPreferenceTab = "shortlists" | "saved_classes"

/** The two steps of adding a preference from a shortlist, as tabs the host drives. */
export function AddPreferenceTabs({
  active,
  onShowShortlists,
}: {
  active: AddPreferenceTab
  onShowShortlists: () => void
}) {
  const { t } = useTranslation("preferences")

  return (
    <Tabs value={active}>
      <TabsList>
        <TabsTrigger value="shortlists" onClick={onShowShortlists}>
          {t("tabs.shortlists")}
        </TabsTrigger>
        {/* Saved classes are only reachable through a shortlist, so this
            trigger reports where the user is rather than offering a
            destination. */}
        <TabsTrigger
          value="saved_classes"
          disabled={active !== "saved_classes"}
        >
          {t("tabs.saved_classes")}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
